export default __webpack_public_path__ + "static/media/close-ticket.b2393eb0.svg";